/**
 * Ruoli: chi vede cosa, in quattro schede (28/10/2026). Ha preso il posto della
 * tabella da 17 sezioni per 11 ruoli da cliccare casella per casella. Lorenzo:
 * "ci sono troppi permessi comunque, non si capisce nulla, dobbiamo minimizzare".
 *
 * Ogni scheda: il nome del ruolo, cosa vede in una frase (lib/ruoli.ts) e chi lo
 * ha. Un ruolo vecchio compare solo se qualcuno lo ha ancora, con l'invito a
 * spostarlo. Il ruolo di una persona si cambia dalla sua riga in Utenti.
 * La usano le Impostazioni del computer e del telefono.
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { SPIEGA_RUOLO, ruoliVisibili, ruoloVecchio } from '../../lib/ruoli';

interface RuoloLite { id: string; key: string | null; name: string; color: string; usersCount: number }
interface UtenteLite { id: string; firstName: string; lastName: string; active: boolean; role: { id: string } }

export function RuoliSemplici() {
  const { data: ruoli } = useQuery({ queryKey: ['roles'], queryFn: () => api.get<RuoloLite[]>('/roles') });
  const { data: utenti } = useQuery({ queryKey: ['users', 'stats'], queryFn: () => api.get<{ items: UtenteLite[] }>('/users?pageSize=200') });
  if (!ruoli) return <p className="mute text-[13px]">Carico i ruoli…</p>;

  return (
    <div className="rs">
      <p className="rs-intro">
        Quattro ruoli, ognuno detto in una frase. Il ruolo di una persona si sceglie in <strong>Utenti</strong>, quando la crei o la modifichi.
      </p>
      <div className="rs-griglia">
        {ruoliVisibili(ruoli).map((r) => {
          const chi = (utenti?.items ?? []).filter((u) => u.role.id === r.id && u.active);
          const vecchio = ruoloVecchio(r.key);
          return (
            <article key={r.id} className={`rs-ruolo${vecchio ? ' is-vecchio' : ''}`}>
              <h3 className="rs-nome"><span className="rs-punto" style={{ background: r.color }} aria-hidden />{r.name}</h3>
              <p className="rs-spiega">
                {vecchio
                  ? 'Ruolo vecchio, rimasto a qualcuno: sposta queste persone in uno dei quattro ruoli da Utenti.'
                  : SPIEGA_RUOLO[r.key ?? ''] ?? ''}
              </p>
              <p className="rs-chi">
                {chi.length === 0 ? 'Nessuno ha questo ruolo.' : chi.map((u) => `${u.firstName} ${u.lastName}`).join(', ')}
              </p>
            </article>
          );
        })}
      </div>
    </div>
  );
}
